var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("조직현황")])]), _c('v-tabs', {
    attrs: {
      "grow": "",
      "hide-slider": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/about/organization"
    }
  }, [_vm._v("사회복지법인")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/about/organization/domestic"
    }
  }, [_vm._v("국내사업기관")])], 1)], 1)], 1), _c('section', {
    staticClass: "client-section pt-0"
  }, [_c('v-container', [_c('domestic-organization')], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }